module.exports = __webpack_public_path__ + "img/crunched-smiley.e9b4ea25.svg";